import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/sr.ts
var add = "Dodaj";
var remove = "Ukloni";
var removeAll = "Ukloni sve";
var incomplete = "Pojedina polja nisu ispravno ispunjena.";
var submit = "Pošalji";
var noFiles = "Fajl nije odabran";
var moveUp = "Pomerite se gore";
var moveDown = "Pomeri se dole";
var isLoading = "Učitavanje...";
var loadMore = "Učitaj više";
var next = "Sledeća";
var prev = "Prethodna";
var addAllValues = "Dodajte sve vrednosti";
var addSelectedValues = "Dodajte izabrane vrednosti";
var removeAllValues = "Uklonite sve vrednosti";
var removeSelectedValues = "Uklonite izabrane vrednosti";
var chooseDate = "Izaberite datum";
var changeDate = "Promenite datum";
var close = "Zatvori";
var open = "Otvori";
var accepted = function({
  name
}) {
  return `Molimo prihvatite ${name}`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mora biti posle ${date(args[0])}.`;
  }
  return `${sentence(name)} mora biti u budućnosti.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} može da sadrži samo abecedne znakove.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} može da sadrži samo slova i brojeve.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} može da sadrži samo slova i razmake.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} mora da sadrži abecedne znakove.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} mora da sadrži slova ili brojeve.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} mora da sadrži slova ili razmake.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} mora da sadrži simbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} mora da sadrži velika slova.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} mora da sadrži mala slova.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} mora da sadrži brojeve.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} mora biti simbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} može da sadrži samo velika slova.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} može da sadrži samo mala slova.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mora biti pre ${date(args[0])}.`;
  }
  return `${sentence(name)} mora biti u prošlosti.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Ovo polje je pogrešno konfigurisano i ne može se poslati.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} mora biti između ${a} i ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} se ne podudara.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nije važeći datum, molimo Vas koristite format ${args[0]}`;
  }
  return "Ovo polje je pogrešno konfigurisano i ne može se poslati";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} mora biti između ${date(args[0])} i ${date(args[1])}`;
};
var email = "Unesite ispravnu e-mail adresu.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} se ne završava sa ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} nije dozvoljena vrednost`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} mora biti najmanje jedan karakter.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} mora biti manji ili jednaki od ${max2} karaktera.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} treba da bude ${max2} znakova dugačak.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} mora biti veći ili jednaki od ${min2} karaktera.`;
  }
  return `${sentence(name)} mora biti između ${min2} i ${max2} karaktera.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nije dozvoljena vrednost.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ne može imati više od ${args[0]} ${name}.`;
  }
  return `${sentence(name)} mora biti manji ili jednaki od ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Nisu dozvoljeni formati datoteka.";
  }
  return `${sentence(name)} mora biti tipa: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ne može imati manje od ${args[0]} ${name}.`;
  }
  return `${sentence(name)} mora da ima najmanje ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” nije dozvoljeno ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} mora biti broj.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" или ")} потребан је.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} je obavezno polje.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ne počinje sa ${list(args)}.`;
};
var url = function() {
  return `Unesite važeću URL adresu.`;
};
var invalidDate = "Izabrani datum je nevažeći.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var sr_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, sr_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=sr.mjs.map